import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'
import filterFirstLowerCaseForSpeciality from 'common/filters/filterFirstLowerCaseForSpeciality'
import type { ApiAppointmentRestrictionsResponseGet } from 'www/vue_components/common/AppointmentRestrictions/api/apiAppointmentRestrictions.types'
import type { RestrictionsData } from 'www/vue_components/common/AppointmentRestrictions/types'

export default function getDoctorAppointmentRestrictionsDataList(
  restrictions: ApiAppointmentRestrictionsResponseGet,
): RestrictionsData[] {
  const options = { ns: getUserLanguage() }

  return restrictions.filter(item => item.restrictions_appointment.length)
    .map(item => ({
      title: i18next.t('Как {spec}', { ...options, spec: filterFirstLowerCaseForSpeciality(item.speciality_name) }),
      restrictions: item.restrictions_appointment,
    }))
}
